import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import axios from "axios";
import { setTitle } from "../../redux/titleSlice";
import TranslateWidget from "../Shared/TranslateWidget/TranslateWidget";
import EditContactForm from "./EditContactForm"; // reuse same UI component

export default function ViewContactForm() {

  const { contactFormSlug } = useParams();
  const dispatch = useDispatch();
  const childStateRef = useRef();

  const [currentPage, setCurrentPage] = useState(0);
  const [length, setLength] = useState(1);
  const [sharedUserDetail, setSharedUserDetail] = useState({});
  const [questions, setQuestions] = useState([]);

  // 🎯 Set background
  useEffect(() => {
    const styleTag = document.createElement("style");
    styleTag.innerHTML = "body { background-color: #f1f4f9 !important; }";
    document.head.appendChild(styleTag);
    return () => document.head.removeChild(styleTag);
  }, []);

useEffect(() => {
  const fetchContactForm = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/showContactForm/${contactFormSlug}`
      );


      setQuestions(response.data.questions);

    } catch (error) {
      console.error("Error fetching contact form:", error);
    }
  };

  if (contactFormSlug) {
    fetchContactForm();
  }
}, [contactFormSlug]);

  // 🎯 Submit Contact Form
  const handleSubmit = async () => {
    const answers = childStateRef.current.getQuestion(); // must return filled values

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/submitContactForm/${contactFormSlug}/submit`,
        { answers }
      );


      if (response.data.message) {
        setCurrentPage(length); // show thank-you page
      }

    } catch (error) {
      console.error("Error submitting contact form:", error);
    }
  };

  // 🎯 Next Page Logic
  const handleNextPage = async () => {
    if (currentPage === length - 1) {
      await handleSubmit();
    } else {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <>
      <div className="customer-view-translate-bar bg-light border-bottom">
        <div className="customer-view-translate-bar-inner">
          <TranslateWidget />
        </div>
      </div>
      <div
        className="container-fluid p-lg-0 py-lg-3 p-md-5 p-3"
        style={{ display: "block ruby", textAlign: "center" }}
      >
      <div className="row g-lg-5 g-md-5 g-3 px-lg-5">
        <div className="col-md-12 center8" style={{ width: "750px" }}>

          {/* FORM PAGE */}
          {currentPage < length && (
            <>
              <div className="pagination-controls col-md-12 text-end">
                <span>Page {currentPage + 1} of {length}</span>
                <button
                  onClick={handleNextPage}
                  className="Nxt"
                >
                  Submit
                </button>
              </div>

              <div
                className="form_container"
                style={{
                  margin: "0px",
                  padding: "0px",
                  textAlign: "left",
                  boxShadow:
                    "rgba(0, 0, 0, 0.2) 0px 4px 8px 0px, rgba(0, 0, 0, 0.19) 0px 6px 20px 0px"
                }}
              >
                <EditContactForm ref={childStateRef}
                questions={questions} 
                />
              </div>
            </>
          )}

          {/* THANK YOU PAGE */}
          {currentPage === length && (
            <div style={{ width: "75%", margin: "0px auto", textAlign: "center" }}>
              <div className="logo" style={{ width: "50%", margin: "0px auto" }}>
                {sharedUserDetail?.Secondary_Logo && (
                  <img
                    src={
                      process.env.REACT_APP_BACKEND_URL +
                      sharedUserDetail.Secondary_Logo
                    }
                    alt="Logo"
                    className="img-fluid"
                    style={{ maxWidth: "200px" }}
                  />
                )}
              </div>

              <div style={{ fontSize: "26px", marginTop: "20px" }}>
                <b>All done!</b>
              </div>

              <div style={{ margin: "15px" }}>
                Thank you for contacting us. Your message has been successfully submitted.
              </div>

              <div>
                If needed, we will get back to you shortly.
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
    </>
  );
}